export const AppContainerId = 'veilederInntektskalkulator';
export const boksA = 'inntektkalk-boks-a';
export const boksB = 'inntektkalk-boks-b';